import { default as Goal } from "./Goal/lang.en";
import { default as Goals } from "./Goals/lang.en";
import { default as KeyResult } from "./KeyResult/lang.en";

export default {
	Goal,
	Goals,
	KeyResult,
	validation: {
		goalTitleMissing: "Goal must have a title.",
		goalTitleLength: "Goal title is too long (max {length} characters).",
		goalAssignedTeamMissing: "A team must be assigned.",
		goalConfidenceLevelMissing: "Missing confidence level.",
		goalConfidenceLevelInvalid: "Invalid confidence level.",
		goalStartDateInvalid: "Invalid start date.",
		goalEndDateInvalid: "Invalid end date.",
		goalEndDateOrientation: "Cannot end before starting.",
		goalCommentLength: "Comment is too long (max {length} characters).",
		keyResultBinaryValueInvalid: "Invalid value.",
		keyResultNumericValueInvalid: "Must be a valid number.",
		keyResultNumericValueGTEQ0: "Cannot be less than zero.",
		keyResultNumericValueGT0: "Must be greater than zero.",
		keyResultNumericValueLTEQ100: "Must be less than or equal to 100.",
		keyResultNameMissing: "Name is required.",
		keyResultConfidenceLevelInvalid: "Invalid confidence level.",
		keyResultOwnerMissing: "An owner is required",
		keyResultTypeInvalid: "Invalid type.",
		keyResultCommentLength: "Comment is too long (max {length} characters).",
	},
};
